import { REGEX_SYMBOLS, REGEX_SPECIFIC_SYMBOLS } from '../../common';

export const getSanitizedText = (text: string | null) => {
  return text?.replaceAll(REGEX_SYMBOLS, '').trim().toLowerCase() ?? '';
};

export const getRegexSafeText = (text: string | null) => {
  return (
    text?.replace(REGEX_SPECIFIC_SYMBOLS, '\\$&').trim().toLowerCase() ?? ''
  );
};
